import authHeader from './auth-header'
import api from './api.service'

const API_URL = window._env_.REACT_APP_API_HOST

class RepostsService {
  getSimulationCampaignsReport(format, id) {
    const version = format == 'csv' ? 'V1' : 'V2'
    return api.get(
      API_URL + '/v1/reports/simulation-campaigns/' + id + '/activity?format=' + format + '&version=' + version,
      {
        headers: authHeader(),
        responseType: 'blob'
      }
    )
  }
  getSimulationCampaignsOverviewReport(format, id) {
    const version = format == 'csv' ? 'V1' : 'V2'
    return api.get(
      API_URL + '/v1/reports/simulation-campaigns/' + id + '/overview?format=' + format + '&version=' + version,
      {
        headers: authHeader(),
        responseType: 'blob'
      }
    )
  }
  getBreachesReport(format) {
    return api.get(API_URL + '/v1/reports/breaches?format=' + format, {
      headers: authHeader(),
      responseType: 'blob'
    })
  }
  getUsersReport(format) {
    return api.get(API_URL + '/v1/reports/users?format=' + format, {
      headers: authHeader(),
      responseType: 'blob'
    })
  }
  getGroupsReport(format) {
    return api.get(API_URL + '/v1/reports/groups?format=' + format, {
      headers: authHeader(),
      responseType: 'blob'
    })
  }
  getCompaniesReport(format) {
    return api.get(API_URL + '/v1/reports/companies?format=' + format, {
      headers: authHeader(),
      responseType: 'blob'
    })
  }
  getWorkflowsReport(format) {
    return api.get(API_URL + '/v1/reports/workflows?format=' + format, {
      headers: authHeader(),
      responseType: 'blob'
    })
  }
  getWorkflowsReportById(format, id) {
    return api.get(API_URL + '/v1/reports/workflows/' + id + '/logs?format=' + format, {
      headers: authHeader(),
      responseType: 'blob'
    })
  }
  getWorkflowsLogsReport(format) {
    return api.get(API_URL + '/v1/reports/workflows/logs?format=' + format, {
      headers: authHeader(),
      responseType: 'blob'
    })
  }
  getThreatsReport(format) {
    return api.get(API_URL + '/v1/reports/threats?format=' + format, {
      headers: authHeader(),
      responseType: 'blob'
    })
  }
  getTrainingPackagesReport(format) {
    return api.get(API_URL + '/v1/reports/training-packages?format=' + format, {
      headers: authHeader(),
      responseType: 'blob'
    })
  }
  getTrainingPackagesReportById(format, id) {
    return api.get(API_URL + '/v1/reports/training-packages/' + id + '/?format=' + format, {
      headers: authHeader(),
      responseType: 'blob'
    })
  }
}

export default new RepostsService()
